import React from 'react'

import {
    EuiText,
    EuiCallOut
  } from '@elastic/eui'

function PrimaryBox() {
  return (
    <EuiCallOut size="m" iconType="gear" color="success" title="Audio Settings">
        <EuiText>
          <p>
            Here you can adjust the amplification of the cameras microphones/audio-in as well as the volume of the audio-out signal.
          </p>
        </EuiText>
    </EuiCallOut>
  );
}

export default PrimaryBox

